import { ReactNode } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome } from '@fortawesome/pro-light-svg-icons'

import { Box, Text } from '@domain-group/suit-theme'

import useCurrentUser from '@hooks/useCurrentUser'
import useUser from '@hooks/useUser'

import handleCallbackAction from '@functions/handleCallbackAction'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

interface SearchResultProps {
  icon: ReactNode,
  result: {
    entityType?: string,
    href: string,
    id?: number,
    priority?: number,
    subtitle: string,
    title: string,
  },
}

const SearchResult = (props: SearchResultProps) => {
  const {
    icon,
    result: {
      entityType, href, id, priority, subtitle, title,
    },
  } = props

  const { currentUser } = useCurrentUser()
  const { callbacks: { loginToRealhub } } = useUser(currentUser)

  const loginToRealhubPayload: HandleCallbackActionParams = {
    callbacks: {
      // @ts-expect-error TS2322
      action: loginToRealhub,
      buildActionParams: () => [{ redirect: `/admin/templates/manage#/edit-page/${id}` }],
    },
    shouldRedirect: true,
    toastText: 'Logged In',
  }

  return (
    <li>
      <a
        href={href}
        onClick={entityType === 'TemplatePage' ? () => handleCallbackAction(loginToRealhubPayload) : () => null}
      >
        <Box
          alignItems="center"
          color="blue"
          fontSize="medium"
          justifyContent="center"
          marginRight="large"
          width={20}
        >
          {/*
           // @ts-expect-error TS2322 */}
          <FontAwesomeIcon icon={icon || faHome} />
        </Box>

        <Box
          alignItems="flexStart"
          flexDirection="column"
          justifyContent="center"
          opacity={priority === 0 ? '0.5' : '1'}
        >
          <Text color="bodyFontColor" fontSize="small">
            {title}
          </Text>

          {subtitle && (
            <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
              {subtitle}
            </Text>
          )}

        </Box>
      </a>
    </li>
  )
}

export default SearchResult
